import React from "react";
import "./Revenue.css";
import revenueimage from "../marketplaceassets/revenueimage.png";

export default function Revenue() {
  return (
    <div id="marketplace-revenue" className="marketmainclass">
      <div className="left">
        <h1>Powerful NFT Marketplace Development Services</h1>
        <p>
Custom NFT marketplace development services focus on building platforms that align with specific business goals, user requirements, and blockchain environments. The complete development process covers everything from concept planning and design to smart contract implementation and deployment, delivering a secure, scalable, and future-ready NFT marketplace.</p>

<p>The platform is designed for smooth performance, intuitive navigation, and long-term flexibility, enabling users to trade NFTs efficiently while maintaining stability and security across the system.
</p>

<div className="list">
  <p className="list-head">Key Features:</p>
  <ul>
    <li>Scalable NFT marketplace architecture</li>
    <li>Multi-creator support with advanced NFT discovery</li>
    <li>High-performance frontend and backend systems</li>
  </ul>
</div>
      </div>
      <div className="right">
        <img src={revenueimage} alt="error" />
      </div>
    </div>
  );
}
